export function isFirstUnreadStatusMessage(message) {
    return message.type === 'status' && message.statusType === 'firstUnreadMessage';
}
